import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { RestrictPhoneDirective } from '../core/directives/restrict-phone.directive';
import { NoSpaceDirective } from '../core/directives/no-space.directive';
import { PositiveIntegerDirective } from '../core/directives/positive-integer.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TimerComponent } from '@esqyre/rental-lib';
import { CurrencyIconDirective } from '../core/directives/custom-currency.directive';

@NgModule({
  declarations: [SidebarComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    RouterModule,
    MatTooltipModule,
    TranslateModule,
    RestrictPhoneDirective,
    NoSpaceDirective,
    PositiveIntegerDirective,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    CurrencyIconDirective,
    TimerComponent
  ],
  exports: [CurrencyIconDirective, SidebarComponent, RestrictPhoneDirective, NoSpaceDirective, PositiveIntegerDirective, TimerComponent]
})
export class SharedModule { }
